import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AVAILABLE_AGENTS } from '../agents'
import { componentClasses, cn } from '../utils/designSystem'
import { ArrowRight, Sparkles } from 'lucide-react'

const AgentsPage = () => {
  const navigate = useNavigate()

  const handleAgentSelect = (agent, query) => {
    if (query) {
      // If query is provided, navigate to agent page with query
      navigate(`/agent/${agent.id}`, { state: { query } })
    } else {
      // If no query, navigate to home and set selected agent ID only
      navigate('/', { state: { selectedAgentId: agent.id } })
    }
  }

  return (
    <div className={cn(componentClasses.main, "min-h-screen p-3 sm:p-6")}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6 sm:mb-8 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-text-primary mb-2">AI Agents</h1>
          <p className="text-sm sm:text-base text-text-secondary px-4">Pilih AI Agent yang sesuai dengan kebutuhan Anda</p>
        </div>

        {/* Agents Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {AVAILABLE_AGENTS.map((agent) => (
            <div
              key={agent.id}
              onClick={() => handleAgentSelect(agent)}
              className="bg-bg-tertiary border border-border-primary rounded-xl p-4 sm:p-5 hover:border-brand-primary transition-all duration-200 cursor-pointer group hover:shadow-lg hover:bg-bg-quaternary"
            >
              {/* Agent Header */}
              <div className="flex items-start space-x-3 sm:space-x-4 mb-3 sm:mb-4">
                <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-brand-primary/10 rounded-xl group-hover:bg-brand-primary/20 transition-colors flex-shrink-0">
                  <agent.icon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-text-primary group-hover:text-brand-primary transition-colors text-sm sm:text-base mb-1">
                    {agent.name}
                  </h3>
                  <p className="text-text-tertiary text-xs uppercase tracking-wide font-medium">
                    {agent.category || 'AI Assistant'}
                  </p>
                </div>
              </div>

              {/* Agent Description */}
              <p className="text-text-secondary text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4 line-clamp-3">
                {agent.description}
              </p>

              {/* Features Tags */}
              {agent.features && agent.features.length > 0 && (
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-4">
                  {agent.features.slice(0, 3).map((feature, index) => (
                    <span
                      key={index}
                      className="px-2 sm:px-3 py-1 bg-bg-quaternary text-text-tertiary text-xs rounded-full border border-border-primary"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              )}

              {/* Action */}
              <div className="flex items-center justify-between pt-2 border-t border-border-primary">
                <span className="text-brand-primary text-xs sm:text-sm font-semibold">
                  Mulai Chat
                </span>
                <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 text-text-tertiary group-hover:text-brand-primary group-hover:translate-x-1 transition-all" />
              </div>
            </div>
          ))}
        </div>

        {/* Coming Soon Section */}
        <div className="mt-8 sm:mt-12 text-center">
          <div className="bg-bg-tertiary border border-border-primary rounded-xl p-6 sm:p-8 hover:bg-bg-quaternary transition-colors">
            <div className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-brand-primary/10 rounded-full mx-auto mb-3 sm:mb-4">
              <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 text-brand-primary" />
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-2">Lebih Banyak Agent Segera Hadir</h3>
            <p className="text-sm sm:text-base text-text-secondary max-w-md mx-auto px-4">
              Kami sedang mengembangkan lebih banyak AI Agent untuk membantu berbagai kebutuhan Anda.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgentsPage